import { defineStore } from 'pinia'
export const useDevicesStore = defineStore('devices', {
    state: () => ({
        devices: {},
        online: {},
        offline: {},
        online_compteur: { number: 0, sitOnline: {} },
        externe: {},
        easyParser: {},
        aeroscope: [],
        relaod: false,
    }),
    actions: {
        setDevices(newDevices) {
            this.devices = {...newDevices.devices}
            this.online = {...newDevices.online}
            this.offline = {...newDevices.offline}
            this.online_compteur = {...newDevices.online_compteur}
            this.externe = {...newDevices.externe}
            this.easyParser = {...newDevices.easyParser}
            this.aeroscope = {...newDevices.aeroscope}
            this.relaod = {...newDevices.relaod}
        }
    }
})
